import React from 'react';
import { useUiStateMatches, sendUiEvent, useUiCtxSelector } from '@/core';
import {
  ActionBarItem,
  Panel,
  SuspenseLoader,
  TabBarProps,
  TextHeading,
} from '@knapsack/toby';

export interface PortalProps {
  ariaLabel: string;
  actionBarLeft?: ActionBarItem[];
  actionBarRight?: ActionBarItem[];
  body?: React.ReactNode;
  footer?: React.ReactNode;
  id: string;
  subTitle?: string;
  tabs?: TabBarProps['tabs'];
  title: string;
}

const Portal = () => {
  const isPortalOpened = useUiStateMatches('portal.opened');
  const portal = useUiCtxSelector((ui) => ui.portal);
  const confirmAction = useUiCtxSelector((ui) => ui.confirmAction);

  return (
    <Panel
      ariaLabel={portal?.ariaLabel}
      actionBarLeft={portal?.actionBarLeft}
      actionBarRight={portal?.actionBarRight}
      footer={portal?.footer}
      id={portal?.id}
      onToggle={() => {
        if (confirmAction) {
          sendUiEvent('confirmAction.open');
        } else {
          sendUiEvent('portal.triggerClose');
        }
      }}
      opened={isPortalOpened}
      overlay
      placement="right"
      size="wide"
      subtitle={portal?.subTitle}
      tabs={portal?.tabs}
      title={
        <>
          {portal?.title && (
            <TextHeading tag="h2" size="small">
              {portal?.title}
            </TextHeading>
          )}
        </>
      }
    >
      <SuspenseLoader>{portal?.body}</SuspenseLoader>
    </Panel>
  );
};

export default Portal;
